import { useMemo, useCallback, forwardRef } from "react";

import classNames from "classnames";

const classNamePrefix = "checkbox-field";

const CheckboxField = forwardRef((props, ref) => {
  const { name, label, disabled, required, error, children, value, onChange } =
    props;

  const labelMemo = useMemo(() => {
    if (children) {
      return children;
    } else {
      return `${label}${required ? " *" : ""}`;
    }
  }, [children, label, required]);

  const onChangeHandler = useCallback(
    (evt) => {
      onChange && onChange(!value);
    },
    [value, onChange]
  );

  return (
    <div className={`${classNamePrefix}__container`}>
      <label
        htmlFor={name}
        className={classNames(`${classNamePrefix}__content`, {
          disabled: disabled,
          invalid: error,
        })}
      >
        {value && (
          <span
            className={classNames(`${classNamePrefix}__icon`, "icon-check")}
          />
        )}
        <input
          ref={ref}
          id={name}
          name={name}
          type="checkbox"
          className={classNames(`${classNamePrefix}__input`, "rounded", {
            checked: value,
            disabled: disabled,
          })}
          value={value}
          disabled={disabled}
          onChange={(evt) => onChangeHandler(evt)}
        />
        <span
          className={classNames(`${classNamePrefix}__label`, {
            disabled: disabled,
          })}
          title={labelMemo}
        >
          {labelMemo}
        </span>
      </label>
      <p className={classNames(`${classNamePrefix}__error`, { show: error })}>
        {error}
      </p>
    </div>
  );
});

export default CheckboxField;
